import React, { Fragment } from "react";
import { ReactSVG } from "react-svg";
import { countryNameHelper, getAssets } from "@unisearch/helpers";
import styles from "./study_admission_session.module.scss";

let colorClasses = [
  styles.green,
  styles.violet,
  styles.blue,
  styles.pink,
  styles.orange,
];

export const StudyAdmissionSession = ({ countryInfo, countryData }) => {
  return (
    <section className={styles.section_admission_session}>
      <div className="container">
        <h2 className={styles.title}>
          Intake Dates and Academic Timelines{" "}
          {countryInfo?.name ? <>({countryNameHelper(countryInfo)})</> : ""}
        </h2>
        <div className={styles.admission_session_wrapper}>
          <ul>
            <img
              className={styles.line}
              src={getAssets("assets/images/study/Line.png")}
              alt="Line"
            />
            {countryData?.admissionSessionTimeline?.map((item, i) => {
              return (
                <Fragment key={i}>
                  {item?.icon !== null && (
                    <li className="relative">
                      <span
                        className={`uni-tooltip ${styles.admission_tooltip}`}
                      >
                        {item?.description}
                      </span>
                      <div
                        className={`${styles.icon_wrapper} ${colorClasses[i]}`}
                      >
                        {/* <ReactSVG
                      src={`/assets/images/study/document-${i + 1}.svg`}
                    /> */}
                        <div className={styles.icon_image_wrapper}>
                          <img src={item?.icon?.src} alt={item?.icon?.alt} />
                        </div>
                      </div>
                      <div className={styles.admission_text}>{item?.name}</div>
                    </li>
                  )}
                </Fragment>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default StudyAdmissionSession;
